import getIn from 'lodash/get';

import { ApiActions } from '../../constants/ApiActions';
import { Map } from '../../lib/ImmutableUtils';
import { createReducer } from '../../lib/ReducerUtils';

const INITIAL_STATE = Map<$TSFixMe>({});
export type EntitiesBrowseSourceState = typeof INITIAL_STATE;

// GENRE ENTITY REDUCER
export default createReducer(INITIAL_STATE, {
  [ApiActions.GET_MUSIC_CATALOG_SUCCESS]: saveGenreData,
});

// CASE FUNCTIONS

function saveGenreData(
  state: EntitiesBrowseSourceState,
  action: $TSFixMe,
): EntitiesBrowseSourceState {
  if (getIn(action, 'response.entities.browseSource')) {
    return state.mergeDeep(action.response.entities.browseSource);
  }
  return state;
}
